import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";
import moment from "moment";

export const getDailyLogs = createAsyncThunk('getDailyLogs', async ({ data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `farm_log_list`,
            params: {
                'farm_id': data?.farm,
                'room_id': data?.room,
                'crop_id': data?.crop,
                'log_date': moment(data?.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const getDailyLogsSlice = createSlice({
    name: 'getDailyLogs',
    initialState: {
        data: '',
    },
    reducers: {
        removeItems: (state, action) => {
            state.data = '';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getDailyLogs.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = '';
            }

        });
        builder.addCase(getDailyLogs.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { removeItems } = getDailyLogsSlice.actions;
export default getDailyLogsSlice.reducer; 